import service from '@/utils/server';

const modName = '/tms/express/';
//分页查询
export const pageInfo = data => {
  return service({
    url: modName + 'selectPendingSchOrderForPlan',
    method: 'post',
    data
  });
};

//快递运输-发运-前置校验
export const expressDispatchPreCheck = data => {
  return service({
    url: modName + 'expressDispatchPreCheck',
    method: 'post',
    data
  });
};


//快递运输-发运提交
export const expressDispatchSubmit = data => {
  return service({
    url: modName + 'expressDispatchSubmit',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/transport/transportExpress/api/index.js